import React from 'react';
import QRCode from 'qrcode.react';
import { injectIntl } from 'react-intl';
import { isNotEmpty, parseClasses } from '../../lib/ep';
import { useCSS } from '../../lib/hooks';

import ActionLink from '../builder/ActionLink';
import HTMLContainer from '../builder/HTMLContainer';
import CopyLink from '../builder/CopyLink';
import FieldLabel from '../builder/FieldLabel';

const SingleLink = (props) => {
	const enabled = props?.enabled ?? true;
	if(!enabled || !isNotEmpty(props, 'url')) return null;

	const clickable = props?.clickable ?? true;

	let classes = ['main_link', 'gui_cutTextOnOverflow'];
	const classname = parseClasses(classes.join(" "), props._class, 'link');

	return (
		<div class="c">
			{(props.pre_extra != undefined) && (
				props.pre_extra
			)}

			<ActionLink
				_href={(clickable) ? props.url : null}
				_target="_blank"
				_class={{ other:classname }}
				autotranslate={false}
			>{props?.visible_url ?? props.url}</ActionLink>

			{(props?.enable_copy ?? true) && (
				<CopyLink copy_link={props.url} />
			)}

			{(props.actions != undefined) && (
				props.actions
			)}
		</div>
	)
};

const LinkCollection = ({ items, ...props }) => {
	useCSS('comp/links.css');

	if(items == undefined || items.length == 0) return null;

	const is_small = props?.is_small ?? false;

	let classes = ['gui_links_list'];
	if(is_small) classes.push('gui_small_list');
	const classname = parseClasses(classes.join(" "), props._class, 'other');

	const parent_type = props?.type ?? 'ul';
	const child_type = props?.subtype ?? 'li';

	return (
		<HTMLContainer type={parent_type} id={props.id} className={classname} style={props.style}>
			{(props.children != undefined) && (
				<span class="title">{props.children}</span>
			)}

			{items.map((item, i) => {
				return (
					<HTMLContainer
						key={`link_${i}`}
						className={parseClasses('', item._class, 'other')}
						type={child_type}
					>
						<div class="gui_padded_in_bottom">
							{isNotEmpty(item, 'label') && (
								<FieldLabel {...item.label} />
							)}

							{item.urls.map((url, u) => {
								return (
									<SingleLink key={`url_${i}_${u}`} {...url} />
								)
							})}

							{(item.extra != undefined) && (
								item.extra
							)}

							{(item.ribbons != undefined) && (
								item.ribbons
							)}
						</div>

						{(item.qr != undefined) && (
							<div class="is_qr">
								<QRCode
									value={item.qr}
									size={100}
								/>
							</div>
						)}
					</HTMLContainer>
				)
			})}

			{props.extra_custom_component != undefined && (
				<HTMLContainer
					className={parseClasses('', props.extra_custom_component_class, 'other')}
					type={child_type}
				>
					{props.extra_custom_component}
				</HTMLContainer>
			)}
		</HTMLContainer>
	)
};

export default injectIntl(LinkCollection);